import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/private/pagination";

const Interview = () => {
  const { token, authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [interviews, setInterviews] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filtros
  const [filter, setFilter] = useState({
    searchQuery: "",
  });

  // PAGINACIÓN
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  useEffect(() => {
    if (!token) return;

    const loadInterviews = async () => {
      setLoading(true);
      const data = await authFetch(ENDPOINTS.getInterview);

      if (data.success) setInterviews(data.entrevistas);
      else setInterviews([]);

      setLoading(false);
    };

    loadInterviews();
  }, [token, authFetch]);

  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
    setCurrentPage(1);
  };

  // FORMATEAR FECHA
  const formatDate = (dateString) => {
    if (!dateString) return "---";

    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }) + 
    " " +
    date.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // FILTRO
  const handleSearch = () => {
    const query = String(filter.searchQuery || "").toLowerCase();

    return interviews.filter((item) => {
      const document = String(item.document || "").toLowerCase();
      const firstName = String(item.first_name || "").toLowerCase();
      const lastName = String(item.last_name || "").toLowerCase();

      const fullName = `${firstName} ${lastName}`;

      return (
        document.includes(query) ||
        fullName.includes(query)
      );
    });
  };


  const filteredInterviews = handleSearch();

  // PAGINACIÓN
  const totalPages = Math.ceil(filteredInterviews.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredInterviews.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const handleViewInterviewPDF = (id_entrevista) => {
  const url = `${ENDPOINTS.interviewPdf}?id_entrevista=${id_entrevista}`;
  window.open(url, "_blank");
};


  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  if (loading) return <p>Cargando entrevistas...</p>;

  return (
    <div className="container mt-4 p-4">
      {/* Encabezado */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Lista de Entrevistas</h2>
        <button
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/interview/createInterview")}
        >
          <i className="bi bi-plus-lg me-1"></i> Crear Entrevista
        </button>
      </div>

      {/* Filtros */}
      <div className="row mb-3">
        <div className="col-md-8">
          <label className="m-1">Buscar por documento o nombre</label>
          <input
            type="text"
            name="searchQuery"
            className="form-control"
            value={filter.searchQuery}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-4">
          <label className="m-1">Tipo de búsqueda:</label>
          <select
            className="form-select"
            name="searchBy"
            value={filter.searchBy}
            onChange={handleFilterChange}
          >
            <option value="document">Documento</option>
            <option value="name">Nombre</option>
          </select>
        </div>
      </div>

      {/* Tabla */}
      {currentRecords.length > 0 ? (
        <>
          <table className="table table-hover">
            <thead className="table-secondary">
              <tr>
                <th>Documento</th>
                <th>Colaborador</th>
                <th>Cargo</th>
                <th>Fecha</th>
                <th style={{ width: "180px" }}>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {currentRecords.map((intv) => (
                <tr key={intv.Id}>
                  <td>{intv.document}</td>
                  <td>
                    {intv.first_name} {intv.last_name}
                  </td>
                  <td>{intv.position_name}</td>
                  <td>{formatDate(intv.created_at)}</td>

                  <td>
                    <button
                      className="btn btn-outline-purple btn-sm me-2"
                      onClick={() => handleViewInterviewPDF(intv.Id)}
                    >
                      <i className="bi bi-eye-fill me-1"></i> Ver PDF
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />
        </>
      ) : (
        <p>No hay entrevistas registradas.</p>
      )}
    </div>
  );
};

export default Interview;
